import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import Modal from 'react-modal'

import QToolsDeliveriesSection from './QToolsDeliveriesSection'
import QToolsDeliveriesSMSHistory from './QToolsDeliveriesSMSHistory'
import QToolsDeleteDelivery from './QToolsDeleteDelivery'
import useSWR from '../../hooks/useSWR'
import './QToolsStyles.css'

const QToolsModal = ({ isOpen, closeModal, deliveries }) => {
  const { data: smss, mutate: mutateSmss } = useSWR(deliveries && '/subject/admin/s_sms', { deliveryIds: (deliveries || []).map((d) => d._id) })

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={{
        content: {
          top: '15vh',
          left: '25vh',
          bottom: '15vh',
          right: '25vh',
        },
      }}
    >
      <div className="qCloseButton" onClick={closeModal}>
        Stäng
      </div>

      {isOpen && (
        <Grid fluid>
          <Row>
            <Col lg={12} xs={12} style={{ textAlign: 'center' }}>
              <h2>QToolsModal</h2>
            </Col>
          </Row>

          <QToolsDeliveriesSection deliveries={deliveries} mutateSmss={mutateSmss} />

          <QToolsDeleteDelivery deliveries={deliveries} closeModal={closeModal} />

          <QToolsDeliveriesSMSHistory deliveries={deliveries} smss={smss} />
        </Grid>
      )}
    </Modal>
  )
}

export default QToolsModal
